import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { usePrefersReducedMotion } from "@/hooks/usePrefersReducedMotion";
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface ScrollRevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}

export function ScrollReveal({ children, className, delay = 0 }: ScrollRevealProps) {
  const [ref, isVisible] = useScrollAnimation<HTMLDivElement>(0.1);
  const reducedMotion = usePrefersReducedMotion();

  const animate = !reducedMotion && !isVisible;

  return (
    <div
      ref={ref}
      className={cn("opacity-100", !reducedMotion && "transition-transform duration-[400ms] ease-out", className)}
      style={{
        transform: animate ? "translateY(20px)" : "translateY(0)",
        transitionDelay: reducedMotion ? undefined : `${delay}ms`,
      }}
    >
      {children}
    </div>
  );
}
